import { render } from "./OpenAIAPIBotSettings.vue?vue&type=template&id=592f38eb"
import script from "./OpenAIAPIBotSettings.vue?vue&type=script&lang=js"
export * from "./OpenAIAPIBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__